<template>
  <div>
    <vx-card title="Perbarui User" subtitle="Isi data dengan benar">
      <template slot="actions">
          <div class="vx-row">
            <div class="vx-col w-full m-0">
              <vs-button icon-pack="feather" class="mt-2" @click="saveData">Simpan Data</vs-button>
              <vs-button to="/users" class="ml-4 mt-2" type="border" color="danger">Kembali</vs-button>
            </div>
          </div>
      </template>
      <div slot="no-body" class="p-6">
        <div class="divider mb-4"></div>
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full">
            <div class="w-full">
              <label class="text-sm opacity-75">Nama Lengkap</label>
              <vs-input class="w-full" v-model="form.name" name="name" />
              <span class="text-danger text-sm"  v-show="errors.has('name')">{{ errors.first('name') }}</span>
            </div>
            <div class="w-full mt-4">
              <label class="text-sm opacity-75">Username</label>
              <vs-input class="w-full" v-model="form.username" username="username" />
              <span class="text-danger text-sm"  v-show="errors.has('username')">{{ errors.first('username') }}</span>
            </div>
            <div class="vx-row mt-4">
              <div class="vx-col md:w-1/2">
                <label class="text-sm opacity-75">Email</label>
                <vs-input class="w-full" v-model="form.email" v-validate="'required|email|min:3'" name="email" />
                <span class="text-danger text-sm"  v-show="errors.has('email')">{{ errors.first('email') }}</span>
              </div>
              <div class="vx-col md:w-1/2">
                <label class="text-sm opacity-75">No. Handphone</label>
                <vs-input class="w-full" v-model="form.phone" v-validate="'numeric'" name="phone" />
                <span class="text-danger text-sm"  v-show="errors.has('phone')">{{ errors.first('phone') }}</span>
              </div>
            </div>
          </div>


          <div class="vx-col md:w-1/2 w-full">
            <label class="text-sm opacity-75">Foto Profil</label>
            <div class="flex items-start flex-col sm:flex-row">
              <img :src="url" class="rounded mr-4" width="180" height="180" />
              <div>
                <input type="file" @change="addAvatar" class="hidden" ref="update_logo_input" accept="image/*">
                <vs-button  @click="$refs.update_logo_input.click()" class="mr-4 mb-2" type="filled" icon-pack="feather" icon="icon-edit"></vs-button>
                <vs-button @click="removeAvatar()" type="border" color="danger" icon-pack="feather" icon="icon-trash"></vs-button>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row mt-5">
          <div class="vx-col md:w-1/2 w-full">
            <h5 class="text-bold">Reset Password</h5>
            <div class="vx-row items-center">
              <div class="vx-col md:w-1/2">
                <vs-input class="w-full" v-model="form.password" name="password" />
              </div>
              <div class="vx-col md:w-1/2">
                <vs-button color="warning" @click="resetPass" type="border">Reset</vs-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
// Store Module
import moduleEmployee from '@/store/employee/moduleEmployee.js'

export default {
  data () {
    return {
      user: null,
      form:{
        name: null,
        username: null,
        password: null,
        email: null,
        phone: null,
        avatar: null
      },

      url: null
    }
  },
  created () {
    if (!moduleEmployee.isRegistered) {
      this.$store.registerModule('employee', moduleEmployee)
      moduleEmployee.isRegistered = true
    }
    this.getUser()
  },
  computed: {
    validateForm () {
      return !this.errors.any() &&
        this.name !== '' &&
        this.username !== '' &&
        this.email !== ''  &&
        this.phone !== ''
    },
  },
  methods: {
    addAvatar (e) {
      const file = e.target.files[0]
      this.url = URL.createObjectURL(file)
      this.form.logo = file
    },

    removeAvatar () {
      this.url = null
      this.form.logo = null
    },

    getUser(){
      this.$store.dispatch('user/findUser', this.$route.params.id).
      then(
        resp => {
          this.user = resp.data.data
          this.form = {
            name: this.user.employee.name,
            username: this.user.username,
            email: this.user.employee.email,
            phone: this.user.employee.phone,
          }
          this.url = `${this.$storagePath + this.user.employee.avatar}`
        }
      ).catch(
        err => {
          this.$vs.notify({
            color: 'danger',
            title: 'Oops..',
            text: err.response.data.message
          })
        }
      )
    },
    resetPass(){
      const formData = new FormData()
      formData.set('password', this.form.password)

      this.$store.dispatch('user/resetPass', {
        id: this.user.id,
        body: {
          password: this.form.password
        }
      }).then(
        resp => {
          this.$vs.notify({
                color: 'success',
                title: 'Success',
                text: resp.data.message
              })
          this.form.password = null
        }
      ).catch(
        err => {
          this.$vs.notify({
            color: 'danger',
            title: 'Oops..',
            text: err.response.data.message
          })
        }
      )
    },
    saveData () {

      this.$validator.validateAll().then(result => {
        if (result) {

          const formDataUpdate = new FormData()
          formDataUpdate.set('name', this.form.name)
          formDataUpdate.set('username', this.form.username)
          formDataUpdate.set('email', this.form.email)
          formDataUpdate.set('phone', this.form.phone)
          formDataUpdate.append('avatar', this.form.logo)

          this.$store.dispatch('user/updateUser', {
            id: this.user.id,
            body:  formDataUpdate })
            .then(resp => {
              this.$vs.notify({
                color: 'success',
                title: 'Sucess',
                text: resp.data.message
              })
              this.getUser()
            })
            .catch(err => {
              this.$vs.notify({
                color: 'danger',
                title: 'Oops..',
                text: err.response.data.message
              })
            })
        }
      })
    }
  }
}
</script>

<style lang="scss">
.divider {
  background: #E0E0E0;
  height: 1px;
}
</style>
